import { create, createNonCss } from "./create.js";
/**
 * @public
 */
export const elevationRecipe = createNonCss("elevation-recipe").withDefault({
    evaluate: (element, size) => {
        let ambientOpacity = 0.12;
        let directionalOpacity = 0.14;
        if (size > 16) {
            ambientOpacity = 0.2;
            directionalOpacity = 0.24;
        }
        const ambient = `0 0 2px rgba(0, 0, 0, ${ambientOpacity})`;
        const directional = `0 calc(${size} * 0.5px) calc((${size} * 1px)) rgba(0, 0, 0, ${directionalOpacity})`;
        return `${ambient}, ${directional}`;
    },
});
/** @public */
export const elevationCardRestSize = createNonCss("elevation-card-rest-size").withDefault(4);
/** @public */
export const elevationCardHoverSize = createNonCss("elevation-card-hover-size").withDefault(8);
/** @public */
export const elevationCardActiveSize = createNonCss("elevation-card-active-size").withDefault(2);
/** @public */
export const elevationCardFocusSize = createNonCss("elevation-card-focus-size").withDefault(4);
/** @public */
export const elevationCardRest = create("elevation-card-rest").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationCardRestSize.getValueFor(element)));
/** @public */
export const elevationCardHover = create("elevation-card-hover").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationCardHoverSize.getValueFor(element)));
/** @public */
export const elevationCardActive = create("elevation-card-active").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationCardActiveSize.getValueFor(element)));
/** @public */
export const elevationCardFocus = create("elevation-card-focus").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationCardFocusSize.getValueFor(element)));
/** @public */
export const elevationTooltipSize = createNonCss("elevation-tooltip-size").withDefault(16);
/** @public */
export const elevationTooltip = create("elevation-tooltip").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationTooltipSize.getValueFor(element)));
/** @public */
export const elevationFlyoutSize = createNonCss("elevation-flyout-size").withDefault(32);
/** @public */
export const elevationFlyout = create("elevation-flyout").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationFlyoutSize.getValueFor(element)));
/** @public */
export const elevationDialogSize = createNonCss("elevation-dialog-size").withDefault(128);
/** @public */
export const elevationDialog = create("elevation-dialog").withDefault((element) => elevationRecipe
    .getValueFor(element)
    .evaluate(element, elevationDialogSize.getValueFor(element)));
